export const nav_carbon = "Carbon";
export const nav_builds = "Builds";
export const nav_atelier = "Atelier";
export const nav_models = "Models";
export const nav_process = "Process";
export const nav_contact = "Contact";
export const nav_about = "About";
export const nav_cta = "Start Your Build";

export const hero_tagline = "Crafted in Carbon. Built Without Compromise.";
export const hero_cta_primary = "Configure Yours";
export const hero_cta_secondary = "Explore Models";
export const hero_scroll = "Scroll to Discover";
export const hero_video_toggle = "Video";
export const hero_slides_toggle = "Slides";
export const hero_mute = "Mute";
export const hero_unmute = "Unmute";

export const manifest_title = "The Orvanthe Manifesto";
export const manifest_text = "We engineer beyond convention. Every component is scrutinized, every surface refined. Carbon fiber isn't a material choice—it's our foundation. Performance isn't a feature—it's our obsession. We don't follow trends. We set standards.";

export const manifest_line1 = "This is not styling.";
export const manifest_line2 = "This is reconstruction.";
export const manifest_line3 = "3D scanned. Engineered. Hand-finished.";

export const carbon_title = "Carbon Division";
export const carbon_subtitle = "Engineering Excellence";
export const carbon_desc = "Our Carbon Division represents the pinnacle of lightweight engineering. Every component is meticulously crafted from aerospace-grade carbon fiber, reducing weight while maximizing structural integrity and performance.";
export const carbon_cta = "Explore Carbon Tech";

export const carbon_division_label = "DIVISION 01";
export const carbon_division_title1 = "CARBON";
export const carbon_division_title2 = "DIVISION";
export const carbon_division_desc = "Every component is engineered from raw composite to finished part in-house. No outsourcing. No compromise.";
export const carbon_custom_config = "Custom configurations available for all platforms.";
export const carbon_request_build = "REQUEST CUSTOM BUILD";
export const carbon_view_details = "VIEW DETAILS";
export const carbon_materials_label = "MATERIALS";
export const carbon_process_label = "PROCESS";

export const builds_title = "Signature Builds";
export const builds_subtitle = "Masterpieces in Motion";
export const builds_view = "View Build";

export const builds_limited_series = "Limited Series";
export const builds_each_build = "Each build is a unique statement. Engineered to perfection. Limited to ten.";
export const builds_view_project = "VIEW PROJECT";

export const engineering_title = "Engineering Details";
export const engineering_subtitle = "Precision in Every Component";
export const engineering_tab_chassis = "Chassis";
export const engineering_tab_aero = "Aerodynamics";
export const engineering_tab_power = "Powertrain";
export const engineering_chassis_title = "Carbon Monocoque Chassis";
export const engineering_chassis_desc = "Our proprietary carbon fiber monocoque chassis delivers exceptional rigidity while maintaining minimal weight. Every layer is precisely engineered for optimal strength-to-weight ratio.";
export const engineering_aero_title = "Active Aerodynamics";
export const engineering_aero_desc = "Intelligent aerodynamic systems adapt in real-time, optimizing downforce and drag for every driving condition. Wind tunnel tested, track proven.";
export const engineering_power_title = "Hybrid Powertrain";
export const engineering_power_desc = "Advanced hybrid technology combines raw power with efficiency. Electric motors provide instant torque while the combustion engine delivers sustained performance.";

export const engineering_technical_spec = "Technical Specification";
export const engineering_headline1 = "Engineered to";
export const engineering_headline2 = "exact tolerances.";
export const engineering_body = "Every number below is measured, not estimated. Our process is built on aerospace-grade methodology applied to automotive carbon construction.";
export const engineering_process_overview = "Process Overview";
export const engineering_docs_note = "Full technical documentation available upon project inquiry";
export const engineering_request_docs = "Request Documentation";

export const atelier_title = "Interior Atelier";
export const atelier_subtitle = "Bespoke Craftsmanship";
export const atelier_desc = "Our Interior Atelier transforms cabins into personalized sanctuaries. Every stitch, every surface, every detail is tailored to your vision. From hand-selected leathers to custom carbon weaves, we craft interiors that reflect your individuality.";
export const atelier_cta = "Design Your Interior";

export const atelier_craftsmanship_label = "Craftsmanship";
export const atelier_headline = "INTERIOR / ATELIER";
export const atelier_body = "Where materials meet mastery. Every stitch, every surface, engineered for perfection.";
export const atelier_material_label = "MATERIAL";
export const atelier_our_services = "OUR SERVICES";
export const atelier_schedule = "SCHEDULE CONSULTATION";

export const performance_title = "Performance Line";
export const performance_subtitle = "Uncompromising Power";
export const performance_spec_power = "Power Output";
export const performance_spec_torque = "Peak Torque";
export const performance_spec_weight = "Curb Weight";
export const performance_spec_acceleration = "0-100 km/h";
export const performance_spec_top_speed = "Top Speed";
export const performance_cta = "View Specifications";

export const performance_label = "Performance";
export const performance_headline1 = "ENGINEERED";
export const performance_headline2 = "DYNAMICS";

export const models_title = "Models Gallery";
export const models_subtitle = "Explore Our Collection";
export const models_search_placeholder = "Search models...";
export const models_filter_all = "All Models";
export const models_filter_hypercar = "Hypercar";
export const models_filter_gt = "GT";
export const models_filter_roadster = "Roadster";
export const models_filter_limited = "Limited Edition";
export const models_view = "View Details";
export const models_configure = "Configure";

export const models_config_label = "Configuration · Models";
export const models_headline = "MODELS / GALLERY";
export const models_body = "Choose your base vehicle and configure it according to your vision. Each project is executed individually.";
export const models_available = "models available for configuration";
export const models_ask_another = "ASK ABOUT ANOTHER MODEL";
export const models_swipe = "SWIPE TO EXPLORE";

export const process_title = "Build Process";
export const process_subtitle = "From Vision to Reality";
export const process_step1_title = "Consultation";
export const process_step1_desc = "Begin your journey with our design team. We'll explore your vision, preferences, and performance requirements.";
export const process_step2_title = "Configuration";
export const process_step2_desc = "Select every detail—from carbon weave patterns to interior materials. Visualize your build in real-time.";
export const process_step3_title = "Engineering";
export const process_step3_desc = "Our engineers optimize every component for your specifications, ensuring peak performance and reliability.";
export const process_step4_title = "Fabrication";
export const process_step4_desc = "Master craftsmen bring your vision to life, hand-building each component with precision and care.";
export const process_step5_title = "Delivery";
export const process_step5_desc = "Experience the moment your masterpiece arrives. Comprehensive handover and lifetime support included.";

export const process_label = "Build Process";
export const process_headline1 = "From Raw Carbon";
export const process_headline2 = "to Finished Art.";
export const process_body = "Every ORVANTHE build follows a meticulous six-stage process. No shortcuts. No outsourcing. Each vehicle is a singular expression of precision and craft.";
export const process_start_build = "Start Your Build";
export const process_hours = "Hours Per Build";
export const process_craftsmen = "Master Craftsmen";
export const process_inspection = "Point Inspection";
export const process_warranty = "Structural Warranty";

export const contact_title = "Start Your Build";
export const contact_subtitle = "Let's Create Something Extraordinary";
export const contact_form_name = "Full Name";
export const contact_form_email = "Email Address";
export const contact_form_phone = "Phone Number";
export const contact_form_interest = "I'm Interested In";
export const contact_form_interest_new = "New Build";
export const contact_form_interest_custom = "Custom Project";
export const contact_form_interest_carbon = "Carbon Division";
export const contact_form_interest_atelier = "Interior Atelier";
export const contact_form_interest_inquiry = "General Inquiry";
export const contact_form_message = "Tell Us About Your Vision";
export const contact_form_submit = "Submit Inquiry";
export const contact_form_submitting = "Sending...";
export const contact_form_success = "Thank you! We'll be in touch within 24 hours.";
export const contact_form_error = "Something went wrong. Please try again.";
export const contact_form_required = "This field is required";
export const contact_form_email_invalid = "Please enter a valid email address";

export const contact_configure_label = "Configure";
export const contact_headline1 = "START YOUR";
export const contact_headline2 = "BUILD";
export const contact_body = "Select your package, choose your vehicle, and we'll craft something unrepeatable.";
export const contact_step_package = "Package";
export const contact_step_vehicle = "Vehicle";
export const contact_step_details = "Details";
export const contact_continue = "Continue";
export const contact_back = "Back";
export const contact_edit = "Edit";
export const contact_change = "Change";
export const contact_select_brand = "Select Brand *";
export const contact_select_model = "Select Model *";
export const contact_enter_vehicle = "Enter Your Vehicle *";
export const contact_timeline_label = "Preferred Timeline";
export const contact_timeline_placeholder = "Select timeline";
export const contact_timeline_asap = "As soon as possible";
export const contact_timeline_1_3 = "1–3 months";
export const contact_timeline_3_6 = "3–6 months";
export const contact_timeline_6_12 = "6–12 months";
export const contact_timeline_exploring = "Just exploring options";
export const contact_additional_details = "Additional Details";
export const contact_message_placeholder = "Tell us about your vision — color preferences, specific modifications, inspiration...";
export const contact_submit_inquiry = "Submit Inquiry";
export const contact_processing = "Processing...";
export const contact_success = "Thank you! We'll contact you within 24 hours to discuss your build.";
export const contact_error = "Please fill in all required fields and try again.";
export const contact_location = "Warsaw, PL";

export const news_title = "Latest News";
export const news_subtitle = "Updates from Orvanthe";
export const news_read_more = "Read More";

export const social_title = "Follow Our Journey";
export const social_subtitle = "Behind the Scenes";
export const social_view_post = "View Post";

export const footer_tagline = "Engineering Excellence. Uncompromising Performance.";
export const footer_company = "Company";
export const footer_company_about = "About Us";
export const footer_company_careers = "Careers";
export const footer_company_press = "Press";
export const footer_company_contact = "Contact";
export const footer_models = "Models";
export const footer_models_hypercar = "Hypercar Series";
export const footer_models_gt = "GT Collection";
export const footer_models_roadster = "Roadster Line";
export const footer_models_limited = "Limited Editions";
export const footer_services = "Services";
export const footer_services_carbon = "Carbon Division";
export const footer_services_atelier = "Interior Atelier";
export const footer_services_bespoke = "Bespoke Projects";
export const footer_services_support = "Owner Support";
export const footer_legal = "Legal";
export const footer_legal_privacy = "Privacy Policy";
export const footer_legal_terms = "Terms of Service";
export const footer_legal_cookies = "Cookie Policy";
export const footer_copyright = "© 2024 Orvanthe. All rights reserved.";
export const footer_powered = "Website Builder";

export const footer_copyright_text = "© ORVANTHE 2025. ALL RIGHTS RESERVED.";
export const footer_tagline_short = "Crafted in Carbon. Built Without Compromise.";

export const about_hero_title = "About Orvanthe";
export const about_hero_subtitle = "Engineering the Future of Performance";
export const about_story_title = "Our Story";
export const about_story_text = "Founded on the principle that compromise has no place in automotive excellence, Orvanthe emerged from a vision to redefine what's possible. We don't build cars—we engineer experiences that transcend conventional boundaries.";
export const about_philosophy_title = "Our Philosophy";
export const about_philosophy_text = "Every decision, every component, every detail is guided by an unwavering commitment to perfection. We believe in the purity of purpose, the elegance of engineering, and the relentless pursuit of performance.";
export const about_craftsmanship_title = "Craftsmanship";
export const about_craftsmanship_text = "Our master craftsmen combine traditional techniques with cutting-edge technology. Each vehicle is hand-built, ensuring that every surface, every seam, every component meets our exacting standards.";
export const about_vision_title = "Our Vision";
export const about_vision_text = "We envision a future where performance and sustainability coexist, where technology enhances the driving experience without diminishing it, and where every journey is an expression of automotive artistry.";

export const about_hero_subtitle_short = "Where precision engineering meets artistic vision";
export const about_hero_scroll = "SCROLL";
export const about_story_heading = "The Beginning";
export const about_story_p1 = "Founded in 2018, ORVANTHE emerged from a singular vision: to transcend the boundaries between automotive engineering and fine art. What began as a passion project in a modest workshop has evolved into a globally recognized atelier of automotive excellence.";
export const about_story_p2 = "Our founder, driven by an obsession with perfection and a deep respect for automotive heritage, assembled a team of master craftsmen, engineers, and designers who shared the same uncompromising standards. Together, they pioneered a new approach to automotive customization — one that treats each vehicle as a canvas for innovation.";
export const about_story_p3 = "Every ORVANTHE creation is born from hundreds of hours of meticulous planning, 3D scanning, and hand-finishing. We don't simply modify vehicles; we reconstruct them at the molecular level, reimagining what's possible when artistry meets engineering precision.";
export const about_story_est = "Est. 2018";
export const about_story_since = "PRECISION SINCE DAY ONE";

export const about_craft_heading = "By The Numbers";
export const about_craft_body = "Precision, dedication, and excellence measured";
export const about_craft_quote = "We don't build cars. We sculpt dreams from carbon and steel, engineering poetry that moves at 200 miles per hour.";
export const about_craft_manifesto = "ORVANTHE MANIFESTO";
export const about_craft_stat1_label = "Hours Per Build";
export const about_craft_stat1_desc = "Meticulous attention to every detail";
export const about_craft_stat2_label = "Master Craftsmen";
export const about_craft_stat2_desc = "Decades of combined experience";
export const about_craft_stat3_label = "Precision Tolerance";
export const about_craft_stat3_desc = "Engineering at the microscopic level";
export const about_craft_stat4_label = "Hand-Finished";
export const about_craft_stat4_desc = "No shortcuts, no compromises";

export const about_phil_heading = "Our Philosophy";
export const about_phil_body = "Four principles that guide every decision, every design, every detail";
export const about_phil_p1_title = "Uncompromising Vision";
export const about_phil_p1_desc = "We refuse to accept limitations. Every project begins with a question: what if we could make it better? This relentless pursuit of perfection drives every decision, every measurement, every finish.";
export const about_phil_p2_title = "Artisan Craftsmanship";
export const about_phil_p2_desc = "In an age of automation, we champion the human touch. Our master craftsmen spend years perfecting their skills, ensuring that every surface, every seam, every detail reflects the highest standards of quality.";
export const about_phil_p3_title = "Innovation Without Compromise";
export const about_phil_p3_desc = "We embrace cutting-edge technology — 3D scanning, carbon fiber engineering, advanced aerodynamics — but never at the expense of soul. Technology serves artistry, not the other way around.";
export const about_phil_p4_title = "Client Partnership";
export const about_phil_p4_desc = "Each ORVANTHE creation is a collaboration. We listen, we advise, we refine. Your vision becomes our mission, and together we create something that transcends expectation.";

export const about_vision_heading = "Looking Forward";
export const about_vision_p1 = "The future of ORVANTHE is not about volume — it's about impact. We will never compromise our standards to scale production. Instead, we're investing in next-generation materials, advanced aerodynamics, and sustainable engineering practices that honor both performance and responsibility.";
export const about_vision_p2 = "Our vision extends beyond individual builds. We're creating a legacy of innovation, training the next generation of master craftsmen, and pushing the boundaries of what's possible when art and engineering converge.";
export const about_vision_p3 = "Every ORVANTHE vehicle is a statement: that excellence cannot be rushed, that beauty requires patience, and that true luxury is measured not in price, but in the pursuit of perfection.";
export const about_vision_sustain_title = "Sustainable Innovation";
export const about_vision_sustain_desc = "Carbon-neutral manufacturing by 2026";
export const about_vision_academy_title = "Craftsman Academy";
export const about_vision_academy_desc = "Training the next generation of artisans";
export const about_vision_materials_title = "Future Materials";
export const about_vision_materials_desc = "Pioneering aerospace-grade composites";
export const about_vision_statement = "This is not styling. This is reconstruction.";

export const back_to_top = "Back to top";

export const common = {
  nav: {
    carbon: 'CARBON',
    builds: 'BUILDS',
    atelier: 'ATELIER',
    performance: 'PERFORMANCE',
  },
  contact: {
    hero: {
      eyebrow: 'Get in Touch',
      title: 'Contact',
      subtitle: 'Reach out to discuss your vision, schedule a studio visit, or inquire about our services.'
    },
    info: {
      title: 'Studio Information',
      address: {
        label: 'Address',
        value: 'Aleje Jerozolimskie 123',
        subvalue: '00-001 Warsaw, Poland'
      },
      email: {
        label: 'Email',
      },
      phone: {
        label: 'Phone',
      },
      hours: {
        label: 'Studio Hours',
        value: 'Monday – Friday: 9:00 – 18:00',
        subvalue: 'Saturday: By Appointment Only'
      },
      social: 'Follow Us'
    },
    visit: {
      title: 'Schedule a Studio Visit',
      description: 'Experience ORVANTHE firsthand. Tour our facility, meet our team, and explore our material library and completed builds.',
      benefit1: 'Private consultation with our design team',
      benefit2: 'Hands-on material and finish selection',
      benefit3: 'View current projects in progress',
      cta: 'Book Your Visit',
      form: {
        title: 'Book Your Studio Visit',
        subtitle: "Select your preferred date and time. We'll confirm availability within 24 hours.",
        name: 'Full Name',
        email: 'Email Address',
        phone: 'Phone Number',
        date: 'Preferred Date',
        time: 'Preferred Time',
        visitors: 'Number of Visitors',
        selectTime: 'Select time',
        notes: 'Additional Notes',
        notesPlaceholder: 'Any specific interests or questions?',
        submit: 'Confirm Booking',
        submitting: 'Submitting...',
        validation: 'Please fill in all required fields.',
        success: {
          title: 'Visit Scheduled',
          message: "Your studio visit has been confirmed. We'll send you a confirmation email shortly."
        }
      }
    },
    form: {
      title: 'Send Us a Message',
      subtitle: 'We typically respond within 24 hours.',
      name: 'Full Name',
      namePlaceholder: 'John Smith',
      email: 'Email Address',
      emailPlaceholder: 'john@example.com',
      phone: 'Phone Number',
      phonePlaceholder: '+48 123 456 789',
      subject: 'Subject',
      subjectPlaceholder: 'Select a subject',
      subjects: {
        general: 'General Inquiry',
        carbon: 'Carbon Division',
        atelier: 'Interior Atelier',
        performance: 'Performance Line',
        build: 'Custom Build Request',
        partnership: 'Partnership Opportunity'
      },
      message: 'Message',
      messagePlaceholder: 'Tell us about your project or inquiry...',
      characters: 'characters',
      submit: 'Send Message',
      sending: 'Sending...',
      validation: 'Please fill in all required fields.',
      maxLength: 'Message cannot exceed 500 characters.',
      success: {
        title: 'Message Sent',
        message: "Thank you for reaching out. We've received your message.",
        response: 'Our team will respond within 24 hours.'
      }
    },
    map: {
      title: 'Find Our Studio',
      subtitle: 'Located in the heart of Warsaw',
      location: 'Studio Location'
    },
    faq: {
      title: 'Frequently Asked Questions',
      subtitle: 'Quick answers to common inquiries',
      q1: {
        question: 'What is the typical timeline for a custom build?',
        answer: 'Most projects take 8-16 weeks from initial consultation to delivery, depending on complexity and material availability. Rush services are available for select packages.'
      },
      q2: {
        question: 'Do you ship internationally?',
        answer: 'Yes, we ship worldwide. All carbon components are carefully packaged and insured. Installation support can be arranged through our partner network.'
      },
      q3: {
        question: 'Can I visit the studio without an appointment?',
        answer: 'We recommend scheduling a visit in advance to ensure our team is available to provide you with a comprehensive tour and consultation.'
      },
      q4: {
        question: 'What payment methods do you accept?',
        answer: 'We accept bank transfers, credit cards, and cryptocurrency. A 50% deposit is required to begin work, with the balance due upon completion.'
      },
      q5: {
        question: 'Do you offer installation services?',
        answer: 'Yes, professional installation is available at our studio or through our certified partner network across Europe and beyond.'
      },
      q6: {
        question: 'What warranty do you provide?',
        answer: 'All ORVANTHE products come with a 2-year warranty covering manufacturing defects. Carbon components include a lifetime structural guarantee.'
      },
      more: 'Still have questions?',
      email: 'Email us directly'
    }
  }
};
